import { useNuxtApp, useRoute } from "#imports";
import { reactive, watch, toValue } from "vue";
import { useCraft } from "./useCraft.mjs";
export const useCraftGraphql = () => {
  const { $i18n } = useNuxtApp();
  const { currentCraftUri, getCurrentCraftUri } = useCraft();
  const route = useRoute();
  const variables = reactive({
    uri: toValue(currentCraftUri),
    site: toValue($i18n?.localeProperties)?.craftSiteHandle
  });
  watch(() => route.path, () => {
    if (Object.hasOwnProperty.call(variables, "uri")) {
      variables.uri = getCurrentCraftUri(route.path, toValue($i18n?.locale?.value));
    }
    if (Object.hasOwnProperty.call(variables, "site")) {
      variables.site = toValue($i18n?.localeProperties)?.craftSiteHandle;
    }
  });
  return { variables };
};
